import axios from "../../services/axios";
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

const buildTimeoutErrorMessage = (error, timeoutMessage) =>
  error?.code === "ECONNABORTED" && timeoutMessage
    ? timeoutMessage
    : error?.response?.data?.details ?? "Oops! Something Went Wrong.";

const questionMapError = (error) => ({
  error: {
    message: error?.response?.data?.details ?? "Unable to update the question map.",
    status: error?.response?.status ?? 504,
  },
});

export const fetchQuestionMap = async ({ aController, file }) => {
  try {
    const response = await axios.get(`${BASE_URL}/admin/question-map`, {
      params: { file },
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return questionMapError(error);
  }
};

export const validateQuestionMap = async ({ aController, content }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/question-map/validate`,
      { content },
      { signal: aController.signal }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return questionMapError(error);
  }
};

export const publishQuestionMap = async ({
  aController,
  file,
  content,
  sha,
  message,
}) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/admin/question-map`,
      { file, content, sha, message },
      { signal: aController.signal }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return questionMapError(error);
  }
};

export const fetchOrganizations = async ({ aController }) => {
  try {
    let url = `${BASE_URL}/admin/organisation`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchOrganization = async ({ aController, id }) => {
  try {
    let url = `${BASE_URL}/admin/organisation/${id}`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const createOrganization = async ({
  aController,
  organization,
  //   isMediaEnabled,
  //   isFanInsightsEnabled,
}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/organisation`,

      {
        name: organization,
        // is_media_enabled: isMediaEnabled,
        // is_faninsights_enabled: isFanInsightsEnabled,
      },

      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const patchOrganization = async ({ aController, id, organisation }) => {
  try {
    // console.log(id, organisation);
    // console.log(JSON.stringify(organisation, null, 2));

    const response = await axios.patch(
      `${BASE_URL}/admin/organisation/${id}`,
      {
        ...organisation,
      },
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const deleteOrganization = async ({ aController, id }) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/admin/organisation/${id}`,
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchUsers = async ({ aController, parameters }) => {
  try {
    let url = `${BASE_URL}/admin/user?${parameters}`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });

    // console.log("fetchUsers", response.data);
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const createUser = async ({ aController, user }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/user`,

      {
        ...user,
      },

      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const patchUser = async ({ aController, id, user }) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/admin/user/${id}`,
      {
        ...user,
      },
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const sendUserLastLogin = async ({ aController, id }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/user/${id}/last_login`,

      {},

      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};
export const deleteUser = async ({ aController, id }) => {
  try {
    const response = await axios.delete(`${BASE_URL}/admin/user/${id}`, {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const bulkDeleteUser = async ({ aController, data }) => {
  try {
    const response = await axios.post(`${BASE_URL}/admin/users/delete`, {
      ...data,
    },
    {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const bulkDeactivateUser = async ({ aController, data }) => {
  try {
    const response = await axios.post(`${BASE_URL}/admin/users/disable`, {
        ...data,
      },
      {
        signal: aController.signal,
      });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};
export const bulkImportUser = async ({ aController, data }) => {
  try {
    const response = await axios.post(`${BASE_URL}/admin/user/bulk`, data,
      {
        signal: aController.signal,
      });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};


export const resetUserPassword = async ({ aController, id }) => {
  try {
    const response = await axios.put(`${BASE_URL}/admin/user/password/${id}`, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const toggleActivateUser = async ({ aController, bool, id }) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/admin/user/${id}`,
      {
        is_active: bool,
      },
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaSessions = async ({
  aController,
  page = 1,
  pageSize = 200,
  sortColumn = "visua_created_at",
  sortDirection = "desc",
  searchQuery = "",
}) => {
  try {
    let url = `${BASE_URL}/media/admin/session?page=${page}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${searchQuery}`;
    // let url = `${BASE_URL}/media/admin/session`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const patchMediaSession = async ({ aController, id, value }) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/media/admin/session/${id}`,
      {
        ...value,
      },
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaSessionMetricsTemplate = async ({
  aController,
  filters = {},
}) => {
  try {
    const params = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "" && value !== false) {
        params[key] = value;
      }
    });
    const response = await axios.get(
      `${BASE_URL}/media/admin/session/bulk-metrics`,
      {
        responseType: "blob",
        params,
        signal: aController.signal,
      }
    );
    const disposition = response.headers?.["content-disposition"] ?? "";
    const filename =
      disposition.match(/filename="?([^";]+)"?/i)?.[1] ??
      "media-session-metrics-template.csv";

    return { data: response.data, filename };
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return {
      error: {
        message: buildTimeoutErrorMessage(
          error,
          "Session metrics template download timed out."
        ),
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaSessionMetricsFilters = async ({ aController }) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/media/admin/session/bulk-metrics`,
      {
        params: { meta: "filters" },
        signal: aController.signal,
      }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return {
      error: {
        message: buildTimeoutErrorMessage(
          error,
          "Loading template filters timed out."
        ),
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaSessionMetricsJob = async ({ aController, jobId }) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/media/admin/session/bulk-metrics`,
      {
        params: { job_id: jobId },
        signal: aController.signal,
      }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return {
      error: {
        message: buildTimeoutErrorMessage(
          error,
          "Checking the recalculation progress timed out."
        ),
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const uploadMediaSessionMetrics = async ({ aController, file }) => {
  try {
    const formData = new FormData();
    formData.append("metrics", file);
    const response = await axios.post(
      `${BASE_URL}/media/admin/session/bulk-metrics`,
      formData,
      {
        signal: aController.signal,
      }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    return {
      error: {
        message: buildTimeoutErrorMessage(
          error,
          "Session metrics upload timed out."
        ),
        status: error?.response?.status ?? 504,
        data: error?.response?.data,
      },
    };
  }
};

export const fetchPermissions = async ({ aController }) => {
  try {
    let url = `${BASE_URL}/permissions`; // Previously /admin/organisation/permissions Oct 24, 2024 v1.50.x
    const response = await axios.get(url, {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaSessionDownloadPreSignedURL = async ({
  aController,
  id,
  type_csv,
}) => {
  try {
    // media/session/2/raw || processed
    let url = `${BASE_URL}/media/admin/session/${id}/source/${type_csv}`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });

    // console.log("fetchMediaSessionPreSignedURL", response.data);
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaSessionUploadPreSignedURL = async ({
  aController,
  id,
  type_csv,
}) => {
  try {
    // media/session/2/raw || processed || override
    let url = `${BASE_URL}/media/admin/session/${id}/source/${type_csv}`;
    const response = await axios.post(url, {
      signal: aController.signal,
    });

    // console.log("session upload presignedURL", response.data);
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const deleteMediaSessionOverrideFile = async ({
  aController,
  sessionId,
}) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/media/admin/session/${sessionId}/source/override`,
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const compareMediaSessionOverrideAggregates = async ({
  aController,
  id,
}) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/media/admin/session/${id}/source/override/compare`,
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const syncMediaSessionOverrideCsvFromDb = async ({
  aController,
  id,
}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/media/admin/session/${id}/source/override/sync-from-db`,
      {},
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const previewSyncMediaSessionOverrideCsvFromDb = async ({
  aController,
  id,
}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/media/admin/session/${id}/source/override/sync-from-db?preview=true`,
      {},
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchMediaBrands = async ({ aController }) => {
  try {
    let url = `${BASE_URL}/media/admin/brand`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const patchMediaBrand = async ({ aController, id, value }) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/media/admin/brand/${id}`,
      {
        ...value,
      },
      {
        signal: aController.signal,
      }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

// Returns all Available Custom Projects (Not Just Permitted)
export const fetchCustomProjects = async ({ aController }) => {
  try {
    let url = `${BASE_URL}/admin/custom_projects`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

// Returns all Available International Countries (Not Just Permitted)
export const fetchInternationalFanInsightsCountries = async ({
  aController,
}) => {
  try {
    let url = `${BASE_URL}/admin/international_countries`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const updateMediaExposures = async ({
  aController,
  reportParameters,
  exposures,
  value,
  timeout,
  timeoutMessage,
}) => {
  try {
    let url = exposures
      ? `${BASE_URL}/media/admin/exposures?${reportParameters}&exposure=${exposures}`
      : `${BASE_URL}/media/admin/exposures?${reportParameters}`;
    const response = await axios.post(
      url,
      {
        ...value,
      },
      {
        signal: aController.signal,
        timeout,
      }
    );
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message: buildTimeoutErrorMessage(error, timeoutMessage),
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const purgeMediaSession = async ({ aController, id }) => {
  try {
    let url = `${BASE_URL}/media/admin/session/${id}`;
    const response = await axios.delete(url, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchProviders = async ({ aController, organizationId}) => {
  try {
    let url = `${BASE_URL}/admin/organisation/${organizationId}/providers`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const deleteProvider = async ({ aController, organizationId, providerId }) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/admin/organisation/${organizationId}/providers/${providerId}`,
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const createProvider = async ({ aController, organizationId, data }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/organisation/${organizationId}/providers`,

      {
        ...data
      },

      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const updateProvider = async ({ aController, organizationId, providerId, data }) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}/admin/organisation/${organizationId}/providers/${providerId}`,

      {
        ...data
      },

      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchProvider = async ({ aController, organizationId, providerId}) => {
  try {
    let url = `${BASE_URL}/admin/organisation/${organizationId}/providers/${providerId}`;
    const response = await axios.get(url, {
      signal: aController.signal,
    });
    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const assignUsersToProvider = async ({ aController, organizationId, providerId, data }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/organisation/${organizationId}/providers/${providerId}/assign`,

      {
        ...data
      },

      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};
